import { DepartureDate, ReturnDate, TravelPoints, TravelType } from '../travels';

export interface ShuttleFilters {
  travelType: TravelType;
  travelPoints: TravelPoints<number | null>;
  departureDate: DepartureDate | null;
  returnDate: ReturnDate | null;
  passengers: number;
}

export const DEFAULT_SHUTTLE_FILTERS_VALUES: ShuttleFilters = {
  travelType: TravelType.OneWay,
  travelPoints: {
    origin: null,
    destination: null,
  },
  departureDate: null,
  returnDate: null,
  passengers: 1,
};
